import { useState, useEffect, createContext } from 'react';
import liff from '@line/liff';

export const LineContext = createContext(null);

const LineContextProvider = ({ children }) => {
  const [lineProfile, setLineProfile] = useState({});
  const [liffToken, setLiffToken] = useState('');
  const [isLiffReady, setIsLiffReady] = useState(false);
  const [lineError, setLineError] = useState(null);
  const [isInClient, setIsInClient] = useState(false);

  useEffect(() => {
    const liffId = process.env.REACT_APP_LIFF_ID;

    const getDecodedProfile = () => {
      const decodedToken = liff.getDecodedIDToken();

      if (!decodedToken?.sub) return {};

      return {
        userId: decodedToken.sub,
        displayName: decodedToken.name,
        pictureUrl: decodedToken.picture,
        email: decodedToken.email,
      };
    };

    liff
      .init({
        liffId,
        withLoginOnExternalBrowser: false,
      })
      .then(async () => {
        const inClient = liff.isInClient();
        setIsInClient(inClient);

        if (!liff.isLoggedIn()) {
          liff.login({ redirectUri: window.location.href });
        } else {
          const token = liff.getAccessToken();

          try {
            const profile = await liff.getProfile();
            setLineProfile(profile?.userId ? profile : getDecodedProfile());
          } catch (e) {
            console.error(e);
            setLineError(e);
            setLineProfile(getDecodedProfile());
          }

          setLiffToken(token);
        }
      })
      .catch((e) => {
        console.error(e);
        setLineError(e);
      })
      .finally(() => {
        setIsLiffReady(true);
      });
  }, []);

  return (
    <LineContext.Provider
      value={{
        liffToken,
        lineProfile,
        isLiffReady,
        lineError,
        liffError: lineError,
        isInClient,
      }}
    >
      {children}
    </LineContext.Provider>
  );
};

export default LineContextProvider;
